import React from "react";
import styled from "styled-components";
import format from "date-fns/format";
import { Divider } from "styled_components/Common/Divider";
import ScrollView from "sub_components/Common/BloxScrollViewNew";

const BodyStyle = styled.div`
  height: 160px;
  display: flex;
  flex-direction: column;
  width: 100%;

  .alert {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    margin-bottom: 10px;
    &:not(:first-child) {
      padding-top: 10px;
    }
  }

  .row {
    display: flex;
    align-items: flex-start;
    .labels21 {
      margin-right: 10px;
      margin-top: 5px;
      min-width: 60px;
    }
    .body10 {
      white-space: wrap;
    }
  }

  .ScrollbarsCustom-Track {
    right: -15px !important;
    top: 0px !important;
  }
  .ScrollbarsCustom-ThumbY {
    background-color: ${(props) => props.theme.account} !important;
    width: 6px !important;
  }
  .ScrollbarsCustom-TrackY:before {
    border-left: none;
  }
  .ScrollbarsCustom-TrackY {
    background-color: ${(props) => props.theme.Cool_Gray_Light_2} !important;
    box-shadow: -1px -1px 1.5px ${(props) => props.theme.Cool_Gray_Light_3} inset,
      1px 1px 1.5px ${(props) => props.theme.Cool_Gray_Med_2} inset;
    width: 6px !important;
  }

  @media screen and (min-width: ${(props) =>
      props.theme.res.medium}) and (max-width: ${(props) =>
      props.theme.res.high}) {
    height: 220px;
    .alert {
      margin-bottom: 20px;
      &:not(:first-child) {
        padding-top: 20px;
      }
    }

    .row {
      .labels21 {
        margin-right: 10px;
        margin-top: 3px;
        min-width: 70px;
      }
    }
    .ScrollbarsCustom-Track {
      right: -15px !important;
      top: 0px !important;
    }

    .ScrollbarsCustom-ThumbY {
      width: 8px !important;
    }
    .ScrollbarsCustom-TrackY {
      width: 8px !important;
    }
  }
  @media screen and (min-width: ${(props) => props.theme.res.high}) {
    height: 380px;
    .alert {
      margin-top: 20px;
      margin-bottom: 20px;

      &:not(:first-child) {
        padding-top: 20px;
      }
    }

    .row {
      .labels21 {
        margin-right: 10px;
        margin-top: 0px;
        min-width: 100px;
      }
    }
    .ScrollbarsCustom-Track {
      right: -15px !important;
      top: 0px !important;
    }

    .ScrollbarsCustom-ThumbY {
      width: 10px !important;
    }
    .ScrollbarsCustom-TrackY {
      width: 10px !important;
    }
  }
`;

export const AlertModalBody = ({ breakpoint, alerts }) => {
  return (
    <BodyStyle className="alerts-modal" breakpoint={breakpoint}>
      <ScrollView>
        {alerts.map((alert, index) => (
          <div className="alert">
            {index !== 0 && <Divider />}
            <div className="row">
              <div className="labels21">Title:</div>
              <div className="body10">{alert?.Summary}</div>
            </div>
            <div className="row">
              <div className="labels21">Date/Time:</div>
              <div className="body10">
                {format(new Date(alert?.CreatedDateTime), "MM-dd-yyyy HH:mm")}
              </div>
            </div>
            {alert?.UDF_FNTAssetLocation !== "0" && (
              <div className="row">
                <div className="labels21">Location:</div>
                <div className="body10">{alert?.UDF_FNTAssetLocation}</div>
              </div>
            )}
            <div className="row">
              <div className="labels21">Description:</div>
              <div className="body10">{alert?.Description}</div>
            </div>
          </div>
        ))}
      </ScrollView>
    </BodyStyle>
  );
};
